import React, { useEffect, useState } from 'react';

const CloudBackground = () => {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="cloud-background">
      {/* Multiple layers of clouds for depth */}
      <div 
        className="cloud-layer cloud-layer-1"
        style={{ transform: `translateY(${scrollY * 0.1}px)` }}
      >
        <div className="cloud cloud-1"></div>
        <div className="cloud cloud-2"></div>
        <div className="cloud cloud-3"></div>
      </div>
      
      <div 
        className="cloud-layer cloud-layer-2"
        style={{ transform: `translateY(${scrollY * 0.15}px)` }}
      >
        <div className="cloud cloud-4"></div>
        <div className="cloud cloud-5"></div>
        <div className="cloud cloud-6"></div>
      </div>
      
      <div 
        className="cloud-layer cloud-layer-3"
        style={{ transform: `translateY(${scrollY * 0.05}px)` }}
      >
        <div className="cloud cloud-7"></div>
        <div className="cloud cloud-8"></div>
      </div>
    </div>
  );
};

export default CloudBackground;
